import { render, staticRenderFns } from "./QuotesImage.vue?vue&type=template&id=a5b0ac24&scoped=true"
import script from "./QuotesImage.vue?vue&type=script&lang=ts"
export * from "./QuotesImage.vue?vue&type=script&lang=ts"
import style0 from "./QuotesImage.vue?vue&type=style&index=0&id=a5b0ac24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b0ac24",
  null
  
)

export default component.exports